import {Component, ReactNode} from 'react';

export default class RenderIf<T = any> extends Component<{
	expression: T,
	children?: ReactNode | ReactNode[] | ((expression: NonNullable<T>) => ReactNode | ReactNode[]),
	render?: (expression: NonNullable<T>) => ReactNode | ReactNode[],
	renderElse?: () => ReactNode | ReactNode[],
}> {
	render() {
		if (!this.props.expression) {
			return this.props.renderElse ? this.props.renderElse() : null;
		}

		const expressionResult = this.props.expression as NonNullable<T>;
		if (typeof this.props.children === 'function') {
			return this.props.children(expressionResult);
		} else if (this.props.children) {
			return this.props.children;
		}

		return this.props.render ? this.props.render(expressionResult) : null;
	}
}
